<script>
import { Line } from "vue-chartjs";
import { mapActions, mapState } from "vuex";

export default {
  name: "DocumentsGraph",
  extends: Line,
  data() {
    return {
      docsPerYear: []
    };
  },
  computed: {
    ...mapState({
      documentsPerYear: state => state.document.documentsPerYear,
      filterFocused: state => state.filter.filterFocused
    })
  },
  watch: {
    documentsPerYear() {
      this.drawGraph();
    },
    filterFocused() {
      this.filterFocusedChanged();
    }
  },
  mounted() {
    this.drawGraph();
  },
  methods: {
    ...mapActions(["loadDocumentsPerYear"]),
    filterFocusedChanged() {
      this.loadDocumentsPerYear().then(() => {
        this.drawGraph();
      });
    },
    drawGraph() {
      let chartData = {
        labels: this.documentsPerYear.map(n => n.year),
        datasets: [
          {
            label: "Docs per year",
            data: this.documentsPerYear.map(n => n.amount),
            backgroundColor: "rgba(206, 212, 218, .5)",
            borderWidth: 1
          }
        ]
      };

      let chartOptions = {
        legend: {
          display: false
        },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                userCallback: label => {
                  // Prevent decimals
                  if (Math.floor(label) === label) {
                    return label;
                  }
                }
              }
            }
          ]
        }
      };

      this.renderChart(chartData, chartOptions);
    }
  }
};
</script>
